var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGroupBuilds(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H20V20H0Z",
    fill: "none",
    opacity: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.292,0H.625A.63.63,0,0,0,0,.625a.63.63,0,0,0,.625.625H17.292a.63.63,0,0,0,.625-.625A.63.63,0,0,0,17.292,0Z",
    transform: "translate(1.042 17.708)",
    fill: "#8963f0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667,0H3.333C.833,0,0,1.492,0,3.333V16.667H15V3.333C15,1.492,14.167,0,11.667,0ZM5.833,12.708h-2.5a.625.625,0,0,1,0-1.25h2.5a.625.625,0,0,1,0,1.25Zm0-3.75h-2.5a.625.625,0,1,1,0-1.25h2.5a.625.625,0,1,1,0,1.25Zm0-3.75h-2.5a.625.625,0,1,1,0-1.25h2.5a.625.625,0,1,1,0,1.25Zm5.833,7.5h-2.5a.625.625,0,1,1,0-1.25h2.5a.625.625,0,0,1,0,1.25Zm0-3.75h-2.5a.625.625,0,1,1,0-1.25h2.5a.625.625,0,1,1,0,1.25Zm0-3.75h-2.5a.625.625,0,1,1,0-1.25h2.5a.625.625,0,1,1,0,1.25Z",
    transform: "translate(2.5 1.667)",
    fill: "#8963f0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGroupBuilds);
export default __webpack_public_path__ + "static/media/icon-group-builds.553143017f68ae4ea21032a8a9a2b62e.svg";
export { ForwardRef as ReactComponent };